export const ROUTES = {
  DASHBOARD: '/dashboard',
  APPOINTMENTS: '/appointments',
  APPOINTMENTS_CREATE: '/appointments/create',
  CALENDAR: '/calendar',
  REPORTS: '/reports',
  SETTINGS: '/settings',
  USERS: '/users',
  USERS_CREATE: '/users/create',
  USERS_EDIT: '/users/edit',
  LOGIN: '/login',
  PROFILE: '/profile',
  VETERINARIANS: '/veterinarians',
  STAFF: '/staff',
  HOME: '/',
  PATIENTS: '/patients',
  PATIENTS_CREATE: '/patients/create',
  PATIENTS_EDIT: '/patients/edit',
  API_HEALTH: '/api-health',
  CONTACTS: '/contacts',
  CLINICS: '/clinics',
  CLINIC_CREATE: '/clinics/create',
  CLINIC_EDIT: '/clinics/edit',
  CLINIC_REGISTER: '/register-clinic',
  CLINIC_REGISTER_SUCCESS: '/register-clinic/success',
  PETS: '/pets',
  PETS_CREATE: '/pets/create',
  PETS_EDIT: '/pets/edit',
  PET_CASES: '/pet-cases',
  REVIEWS: '/reviews',
  ROLE_DEMO: '/role-demo',
  RESOURCES: '/admin/resources',
  TRAINING: '/admin/training',
  HOUSEHOLD_SAFETY: '/admin/household-safety',
  BREEDS: '/admin/breeds',
  FAQ: '/admin/faq',
  BLOG: '/admin/blog',
  BLOG_CREATE: '/admin/blog/create',
  BLOG_EDIT: '/admin/blog/edit/:id',
} as const;
